import { Button, TableCell, TableRow, Typography } from '@mui/material';

export default function DomainListTableRow({ row, rowNumber, selected, onSelectRow, onEditRow, onDeleteRow, onShowGifts, onGenerateGift }) {
  const { ApplicationDomainHostName } = row;

  return (
    <TableRow hover selected={selected}>
      <TableCell>
        <Typography variant="body2">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{ApplicationDomainHostName}</Typography>
      </TableCell>
      <TableCell align="right">
        <Button size="small" className="!ml-4" color="info" variant="contained" onClick={onEditRow}>
          ویرایش
        </Button>

        <Button size="small" color="error" variant="contained" onClick={onDeleteRow}>
          حذف
        </Button>
      </TableCell>
    </TableRow>
  );
}
